export default __webpack_public_path__ + "static/media/book_int_poof.effaec8a.mp3";